export interface CoinConfig {
  prover: string;
  port: string;
  github: string;
  chainUrl: string;
  dualMining: boolean;
}

export const COIN_CONFIG: Record<string, CoinConfig> = {
  neptune: {
    prover: "dr_neptune_prover",
    port: "30127",
    github: "https://github.com/0xdrpool/neptune_v2_cpu_guesser",
    chainUrl: "https://neptune.vxb.ai",
    dualMining: true,
  },
  xnt: {
    prover: "dr_xnt_prover",
    port: "30120",
    github: "https://github.com/0xdrpool/xnt_gpu_guesser",  
    chainUrl: "https://neptunescan.io/blocks",
    dualMining: false,
  },
  pearl: {
    prover: "dr_pearl_prover",
    port: "30148",
    github: "https://github.com/0xdrpool/pearl_gpu_guesser",
    chainUrl: "https://explorer.pearlresearch.ai/blocks?network=mainnet",
    dualMining: false,
  },
};

export const GITHUB_LINKS: Record<string, string> = Object.fromEntries(
  Object.entries(COIN_CONFIG).map(([key, config]) => [key, config.github])
);

export const getCoinConfig = (currency: string): CoinConfig => {
  return COIN_CONFIG[currency] || COIN_CONFIG.neptune;
};
